export const DatePicker = {
  DEFAULT: {
    PLACEHOLDER: "Оберіть дату",
  },
};
